import React from 'react';
import PropTypes from 'prop-types';
import AppStack from '../../common/AppStack';
import AppCard from '../../common/AppCard';
import AppFlexbox from '../../common/AppFlexbox';
import AppText from '../../common/AppText';

const StoreOrderFundraiserInfoCard = ({
  ecomStoreRosterPlayer,
  fundraiserCustomInput
}) =>
  (ecomStoreRosterPlayer || fundraiserCustomInput) && (
    <AppCard radius="md" shadow="xs" style={{ padding: 0 }} withBorder>
      <AppStack style={{ gap: 0 }}>
        <AppStack style={{ flex: 1, padding: 16, gap: 24 }}>
          <AppStack style={{ flex: 1, gap: 8 }}>
            <AppFlexbox
              style={{
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <AppText style={{ fontSize: 16, fontWeight: 500 }}>
                Fundraiser
              </AppText>
            </AppFlexbox>
            {ecomStoreRosterPlayer && (
              <AppStack style={{ gap: 0 }}>
                <>
                  <AppText style={{ fontSize: 14 }}>
                    {ecomStoreRosterPlayer.teamUser?.name ||
                      ecomStoreRosterPlayer.name}
                  </AppText>
                  {ecomStoreRosterPlayer.teamUser && (
                    <AppText style={{ fontSize: 14, color: '#666' }}>
                      {ecomStoreRosterPlayer.teamUser.teamName}
                    </AppText>
                  )}
                </>
              </AppStack>
            )}

            {fundraiserCustomInput && (
              <AppText style={{ fontSize: 14 }}>
                {fundraiserCustomInput}
              </AppText>
            )}
          </AppStack>
        </AppStack>
      </AppStack>
    </AppCard>
  );

StoreOrderFundraiserInfoCard.propTypes = {
  ecomStoreRosterPlayer: PropTypes.object,
  fundraiserCustomInput: PropTypes.string
};

export default StoreOrderFundraiserInfoCard;
